import { render, staticRenderFns } from "./JcdcBrandBar.vue?vue&type=template&id=0b88c424"
import script from "./JcdcBrandBar.vue?vue&type=script&lang=ts"
export * from "./JcdcBrandBar.vue?vue&type=script&lang=ts"
import style0 from "./JcdcBrandBar.vue?vue&type=style&index=0&id=0b88c424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports